/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('.callus, .footer-callus').click(function(event){
          
          if($(document).width() > 800){
            event.stopPropagation();
            return false;
          }

        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        $('.slider').on('init', function(event, slick){
          $('.slick-active').addClass('animateInit');
        });

        $('.slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if($('.slick-active').hasClass('animateInit')){
            $('.animateInit').removeClass('animateInit');
          }
        });

        $('.slider').slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          adaptiveHeight: true,
          speed: 1500,
          autoplaySpeed: 5000,
          autoplay: true
        });

        $('.gallery-container a').featherlight({
            targetAttr: 'href'
        });

        $('a[href*="#"]:not([href="#"])').click(function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            var sub = 118;
            if(this.hash == '#servicesID'){
              console.log('asd');
              sub = sub - 55;
            }
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: (target.offset().top - sub)
              }, 1000);
              return false;
            }
          }
        });

        //Parallax

        var offset, offsetBreak, offsetService;
        var translate = 0, translateBreak = 0, translateService = 0;
        
        function applyParallax(event, element){
          var eleRect = element.getBoundingClientRect();
          var docElem = document.documentElement;
          var body = document.body;
          var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
          var clientTop = docElem.clientTop || body.clientTop || 0;
          var clientHeight = window.innerHeight || docElem.clientHeight || body.clientHeight;
          var eleTop = Math.round( eleRect.top + scrollTop - clientTop );

          if( eleRect.bottom < clientHeight || eleRect.top < clientHeight ) {
            offset = scrollTop - eleTop; 
            translate = Math.round( offset / 4 );
            window.requestAnimationFrame(function(){
              if(translate < 0){
                element.style.transform = 'translate3d( 0, 0, 0)';
              }else{
                element.style.transform = 'translate3d( 0, ' + translate + 'px, 0)';
              }
            });
          }
        }

        function applyParallaxBreak(event, element){
          var eleRect = element.getBoundingClientRect();
          var docElem = document.documentElement;
          var body = document.body;
          var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
          var clientTop = docElem.clientTop || body.clientTop || 0;
          var clientHeight = window.innerHeight || docElem.clientHeight || body.clientHeight;
          var eleTop = Math.round( eleRect.top + scrollTop - clientTop );

          if( eleRect.bottom < clientHeight || eleRect.top < clientHeight ) {
            offsetService = scrollTop - eleTop; 
            translateBreak = Math.round( offsetService / 4 );
            window.requestAnimationFrame(function(){
              //if(translateBreak < -20){
              //  element.style.transform = 'translate3d( 0, -20px, 0)';
              //}else{
                element.style.transform = 'translate3d( -50%, ' + translateBreak + 'px, 0)';
              //}
            });
          }
        }

        function applyParallaxService(event, element){
          var eleRect = element.getBoundingClientRect();
          var docElem = document.documentElement;
          var body = document.body;
          var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
          var clientTop = docElem.clientTop || body.clientTop || 0;
          var clientHeight = window.innerHeight || docElem.clientHeight || body.clientHeight;
          var eleTop = Math.round( eleRect.top + scrollTop - clientTop );

          if( eleRect.bottom < clientHeight || eleRect.top < clientHeight ) {
            offsetBreak = scrollTop - eleTop; 
            translateService = Math.round( offsetBreak / 4 );
            window.requestAnimationFrame(function(){
              if(translateService < 0){
                element.style.transform = 'translate3d( -50%, 0, 0)';
              }else{
                element.style.transform = 'translate3d( -50%, ' + translateService + 'px, 0)';
              }
            });
          }
        }

        // function isScrolledIntoView(elem)
        // {
        //     var docViewTop = $(window).scrollTop();
        //     var docViewBottom = docViewTop + $(window).height();

        //     var elemTop = $(elem).offset().top;
        //     var elemBottom = elemTop + $(elem).height();

        //     return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        // }

        window.addEventListener('scroll', function(event){
          if($(document).width() > 800){
            imagescroll = document.querySelector('.slick-active .img');
            breakscroll = document.querySelector('.break-image .img');
            servicescroll = document.querySelector('.services-image .img');

            applyParallax(event, imagescroll);
            applyParallaxBreak(event, breakscroll);
            applyParallaxService(event, servicescroll);

            $('.fadeIn').each( function(i){
              
                var bottom_of_object = $(this).offset().top;
                var bottom_of_window = $(window).scrollTop() + $(window).height();
                
                if( bottom_of_window > bottom_of_object ){
                  $(this).addClass('fadeIn-animate'); 
                }
                
            });
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
